export default {
  headers: {
    edit_time: 'Editează ora',
    create_time: 'Creează oră',
  },
  labels: {
    select_all: 'Selectează tot',
  },
  buttons: {
    add_opening_time: 'Adaugă oră de deschidere',
    add: 'Adaugă',
    cancel: 'Anulează',
  },
};
